import { render, staticRenderFns } from "./DispensationPopupDetails.vue?vue&type=template&id=deecacde&scoped=true&"
import script from "./DispensationPopupDetails.vue?vue&type=script&lang=js&"
export * from "./DispensationPopupDetails.vue?vue&type=script&lang=js&"
import style0 from "./DispensationPopupDetails.vue?vue&type=style&index=0&id=deecacde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deecacde",
  null
  
)

export default component.exports